import { version, name } from "../../package.json";

export const environment = {
	production: true,
	API: "https://gateway.prod.baseerp.com.br/api",
	API_OAUTH: "https://oauth.prod.baseerp.com.br/uaa/oauth",
	SEGMENT_API_KEY: "qyZKD7RH52vGqPdnOrChusB6Ib6cIQ0U",
	URL_BASEERP: "https://apps.baseerp.com.br/erp",
	URL_BASEERP_JSF_PROBE: "https://apps.baseerp.com.br/probe",
	PROXY_BASEERP: "https://apps.baseerp.com.br/erp",
	CHAT_INTERCOM_APP_ID: "qk2i7f63",
	API_BFF: "https://bff.prod.baseerp.com.br",
	ASAAS_CONFIG_URL: "https://www.asaas.com/config/index",
	ASAAS_LOGIN_URL:
		"https://www.asaas.com/login/auth?customerSignUpOriginChannel=PRODUCT_PAGE_ERP",
	ASAAS_FORGOT_PASSWORD_URL: "https://www.asaas.com/register/forgotPassword",
	HOTJAR_SITE_ID: 3670584,
	HOTJAR_VERSION: 6,
	DATADOG: {
		APPLICATION_ID: "1f03d9d8-1154-4f71-90b7-97a542f0e00e",
		CLIENT_TOKEN: "puba14cc6dae9602a82b2bcdc4c316139a3",
		ENV: "production",
		SERVICE: `${name}:prod`,
		VERSION: String(version),
		logLevel: "debug",
		SESSION_SAMPLE_RATE: 100,
		SESSION_REPLAY_SAMPLE_RATE: 100,
		TRACK_INTERACTIONS: true,
		TRACK_USER_INTERACTIONS: true,
		TRACK_RESOURCES: true,
		TRACK_LONG_TASKS: true,
		USE_PARTITIONED_CROSS_SITE_SESSION_COOKIE: true,
		TRACK_SESSION_ACROSS_SUBDOMAINS: true,
		FORWARD_CONSOLE_LOGS: "all",
		DEFAULT_PRIVACY_LEVEL: "allow",
		USE_CROSS_SITE_SESSION_COOKIE: true,
		TRACK_IFRAMES: true
	},
	VERSION: String(version),
	WEB_PKI_LICENSE:
		"AioAYXBwcy5iYXNlZXJwLmNvbS5icixzYW5kYm94LmJhc2VlcnAuY29tLmJyDgBpcDQ6MTAuMC4wLjAvOAgAU3RhbmRhcmQIAAAYTOdn3t0IAAHkL/sE3lOPMM9m6ianHjZN266GCX5zz2CaCXdbbnccOFH8d7lJclkyt4/l+oTVs0/v6Y/SwmbKr6vs6njY/z6phDow9WSrvjlXA/n90geviVfRFzZqQ2lRBLLae5J7dX0d2ZoOnJm+ebyZ2iKxpS+p/9AtfyoycCie3aixa6AhbEIsQjofLKrRG4iP/Lv7XNvXqhyTTJ+OLCwrqo03CKkgiEz0zhgY2P3GZQplWrTWvDJ0yrtYjCLm4HC5vN2I78T/2TEWh00WqRzkPWY6K81T5twpgatPRxb9PZDLtvDxLogqD0hsbr92Hof/sGChkh8XvzyOcs93U3+yP0WGzIEq"
};
